module.exports = __webpack_public_path__ + "img/kakaotalkChannel.2431a581.svg";